import { APIResponseType } from "../../types/generics/APIResponse.type";
import {
  Business,
  TalentEarnings,
  User,
  UserLoginType,
} from "../../types/user";
import {
  createGetApiHook,
  createPostApiHook,
  createPutApiHook,
} from "./apiHooks";

const GetUserAPI = () => `/users/profile`;
const loginEndpoint = `/auth/login`;
const ssoLoginEndpoint = `/auth/sso-login`;
const updateUsernameEndpoint = `/users/set-username`;
// const GetAllUsers = () => `/users`;
const GetAllUsers = ({ search_key }: { search_key?: any }) =>
  search_key ? `/users?search_key=${encodeURIComponent(search_key)}` : `/users`;

export const useGetUserProfile = createGetApiHook<
  APIResponseType<User | Business>,
  {}
>(GetUserAPI);

export const useGetAllUsers = createGetApiHook<
  APIResponseType<any>,
  { search_key?: any }
>(GetAllUsers);

export const useUserLogin = createPostApiHook<
  {},
  {},
  APIResponseType<UserLoginType>
>(loginEndpoint, {
  isFormDataMethod: false,
});

export const useSocialLogin = createPostApiHook<
  {},
  {},
  APIResponseType<UserLoginType>
>(ssoLoginEndpoint, {
  isFormDataMethod: false,
});

export const useUpdateUsername = createPutApiHook<
  {},
  {},
  APIResponseType<User>
>(updateUsernameEndpoint, {
  isFormDataMethod: false,
});

export const useGetTalentEarnings = createGetApiHook<
  APIResponseType<TalentEarnings>,
  {}
>("/users/talent-earnings");
